module.exports = __webpack_public_path__ + "static/img/P1.c0f721f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/P1.jpg
// module id = RfQJ
// module chunks = 1